import DIApi from './_diApi';

class FundAPI extends DIApi {
  controllerName = 'Funds';
}

export default new FundAPI();
